module.exports = __webpack_public_path__ + "img/运维台1.1a720ef3.png";